function getProdCDN() {
	return window.__transition_cdn_url__ + 'seismic-engagement-viewer-ui/';;
}

if (process.env.NODE_ENV === 'production') {
	__webpack_public_path__ = getProdCDN();
} else {
    // Dynamic assets path override __webpack_public_path__ for old g.__cdn_url__
	const cdnParam = new URLSearchParams(location.search.toLowerCase()).get('cdn');
	__webpack_public_path__ = cdnParam ? new URL(cdnParam).origin + '/static/' : getProdCDN();
}
